/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Software_KeyInputs */

const cs_sreality_software_key = /** @type {(inputs: Sreality_Software_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software key`)
};

const en_sreality_software_key = /** @type {(inputs: Sreality_Software_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software key`)
};

/**
* | output |
* | --- |
* | "Software key" |
*
* @param {Sreality_Software_KeyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_software_key = /** @type {((inputs?: Sreality_Software_KeyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Software_KeyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_software_key(inputs)
	return cs_sreality_software_key(inputs)
});